export const isLocalhost = () => import.meta.url.includes('localhost');

export const isDevEnv = () =>
  import.meta.env.VITE_STRIPE_PUB_KEY.includes('test');
